export const valueOrFallback = (value, fallback = "Not specified") => {
  if (value === null || value === undefined) return fallback
  const text = String(value).trim()
  return text.length > 0 ? text : fallback
}

export const formatJobDate = (dateString, fallback = "Date not specified") => {
  if (!dateString) return fallback

  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) return fallback

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })
}

export const formatJobLocation = (job, fallback = "Location not specified") => {
  const parts = [job?.city, job?.region, job?.country]
    .map((part) => (part === null || part === undefined ? "" : String(part).trim()))
    .filter(Boolean)

  return parts.length > 0 ? parts.join(", ") : fallback
}

export const isJobAcceptingApplications = (job, now = new Date()) => {
  if (!job) return false
  if (job.isDeleted === true) return false
  if (valueOrFallback(job.memberId, "") !== "") return false
  if (valueOrFallback(job.positionStatus, "") !== "Open") return false

  if (!job.closingDate) return true

  const closingDate = new Date(job.closingDate)
  if (Number.isNaN(closingDate.getTime())) return false

  return closingDate > now
}

export const getJobApplicationUnavailableReason = (job, now = new Date()) => {
  if (!job) return "Applications are unavailable for this position."
  if (job.isDeleted === true) return "This position is no longer available."
  if (valueOrFallback(job.memberId, "") !== "") return "This position has already been filled."

  const status = valueOrFallback(job.positionStatus, "")
  if (status !== "Open") return "This position is not currently accepting applications."

  if (job.closingDate) {
    const closingDate = new Date(job.closingDate)
    if (Number.isNaN(closingDate.getTime())) return "This position is missing a valid closing date."
    if (closingDate <= now) return "Applications closed for this position."
  }

  return "Applications are unavailable for this position."
}
